<p-button [outlined]="true" severity="danger" label="Delete" icon="pi pi-trash"
    *ngIf="!isGroupRendered && !disabled && !disabledByEvent" (onClick)="onDeleteClick(params)"></p-button>